import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { ILookup } from "../../screens/lookup/LookupListController";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

interface ILookupPayload extends Omit<ILookup, "id"> {}

export const GET_ALL_LOOKUP = (
  pagination: IPagination,
  search: string,
  advanceSearch: string
) => {
  const searchLookupCategory =
    advanceSearch.length > 0 ? `&lookup_category=${advanceSearch}` : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_lookup.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchLookupCategory}`,
    API_ENDPOINTS.get_all_lookup.method
  );
};
export const DELETE_LOOKUP = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_lookup.url + `/${id}`,
    API_ENDPOINTS.delete_lookup.method
  );
};

export const ACTIVE_INACTIVE_LOOKUP = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_lookup.url + `/${id}`,
    API_ENDPOINTS.active_inactive_lookup.method,
    activeInactiveValue
  );
};

export const GET_LOOKUP_BY_ID = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.get_all_lookup.url + `/${id}`,
    API_ENDPOINTS.get_all_lookup.method
  );
};

export const CREATE_LOOKUP = (payload: ILookupPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_lookup.url,
    API_ENDPOINTS.create_lookup.method,
    payload
  );
};

export const UPDATE_LOOKUP = (payload: ILookupPayload, id: string) => {
  return serviceMaker(
    API_ENDPOINTS.update_lookup.url + `/${id}`,
    API_ENDPOINTS.update_lookup.method,
    payload
  );
};

export const RESTORE_LOOKUP = (id: string, payload: ILookupPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_lookup.url + `/${id}/restore`,
    API_ENDPOINTS.create_lookup.method,
    payload
  );
};
